import React, { Component } from "react";
import { Row, Col, Input, Button, Icon, notification, Card, Select, Tooltip } from "antd";
import _ from "lodash";
import Request, { API_URL } from "../../../request"; //

const { Option } = Select;
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {}; //

let isModal = false;

class BankSetup extends Component {
    state = {
        // Initial row based on your provided schema
        bankList: [{
            companyName: '',
            companyType: '',
            companyEmail: '',
            bankName: '',
            bankAddress: '',
            accountNumber: '',
            accountName: '',
            bankSwiftBicCode: '',
            bankIfscCode: '',
            transitNumber: '',
            institutionNumber: '',
            HSTRegistrationNumber: '',
            companyStatus: 'Active',
            businessId: activeUser.businessId || ""
        }],
        loading: false,
        cardLoading: false
    };


    loadInitialData = async () => {
        isModal = this.props.isModal;
        this.setState({ cardLoading: true });
        let response = await Request.getCompanyDetails();
        if (response && response.data && response.data.length > 0) {
            this.setState({ bankList: response.data });
        }
        this.setState({ cardLoading: false })
    }



    componentDidMount() {
        this.loadInitialData();
    }

    // Add new dynamic row
    addBankRow = () => {
        const newBank = {
            companyName: '',
            companyType: '',
            companyEmail: '',
            bankName: '',
            bankAddress: '',
            accountNumber: '',
            accountName: '',
            bankSwiftBicCode: '',
            bankIfscCode: '',
            transitNumber: '',
            institutionNumber: '',
            HSTRegistrationNumber: '',
            companyStatus: 'Active',
            businessId: activeUser.businessId || ""
        };
        this.setState({ bankList: [...this.state.bankList, newBank] });
    };

    // Remove row logic
    removeBankRow = (index) => {
        let list = _.cloneDeep(this.state.bankList); //
        list.splice(index, 1);
        this.setState({ bankList: list });
    };

    // Handle input change for each row
    handleChange = (index, field, value) => {
        let list = _.cloneDeep(this.state.bankList); //
        list[index][field] = value;
        this.setState({ bankList: list });
    };

    onPrev = () => {
        this.props.onPrev();
    }

    // Final Validation and Submission
    // handleNext = () => {
    //     const that = this; // Avoid restricted-globals error
    //     const { bankList } = this.state;

    //     // Check if all mandatory fields are filled in all rows
    //     const isValid = bankList.every(function (bank) {
    //         return (
    //             bank.companyName &&
    //             bank.companyType &&
    //             bank.companyEmail &&
    //             bank.bankName &&
    //             bank.bankAddress &&
    //             bank.accountNumber &&
    //             bank.accountName &&
    //             bank.companyStatus
    //         );
    //     });

    //     if (!isValid) {
    //         notification.warning({
    //             message: 'Mandatory Fields Missing',
    //             description: 'Please fill all fields marked with * before proceeding.'
    //         });
    //         return;
    //     }

    //     this.setState({ loading: true });

    //     // API Request to save multiple bank records
    //     const payload = {
    //         banks: bankList,
    //         businessId: activeUser.businessId
    //     };
    //     Request.addMultiCompanyDetails(payload).then(function (res) {
    //         that.setState({ loading: false });
    //         if (res && !res.error) {
    //             notification.success({ message: 'Bank Details Saved Successfully' });
    //             if (that.props.onNext) {
    //                 that.props.onNext();
    //             }
    //         } else {
    //             const msg = (res && res.msg) ? res.msg : 'Something went wrong';
    //             notification.error({ message: 'Error Saving', description: msg });
    //         }
    //     });
    // };
    handleNext = async () => {
        const { bankList } = this.state;

        const isValid = bankList.every(bank =>
            bank.companyName &&
            bank.companyType &&
            bank.companyEmail &&
            bank.bankName &&
            bank.bankAddress &&
            bank.accountNumber &&
            bank.accountName &&
            bank.companyStatus
        );

        if (!isValid && isModal) {
            notification.warning({
                message: 'Mandatory Fields Missing',
                description: 'Please fill all fields marked with * before proceeding.'
            });
            return;
        }

        this.setState({ loading: true });

        try {
            const payload = {
                banks: bankList,
                businessId: activeUser.businessId
            };

            const res = await Request.addMultiCompanyDetails(payload);
            this.setState({ loading: false });

            if (res && !res.error) {
                notification.success({ message: 'Bank Details Saved Successfully' });

                if (this.props.onNext) {
                    this.props.onNext();
                }
            } else {
                notification.error({
                    message: 'Error Saving',
                    description: res && res.msg || 'Something went wrong'
                });
            }

        } catch (err) {
            notification.error({
                message: 'API Error',
                description: 'Request failed'
            });
        }
    };

    render() {
        const that = this;
        const { bankList, loading } = this.state;
        const { isModal } = this.props;

        return (
            <div style={{ padding: '20px' }}>
                <div style={{ marginBottom: 25 }}>
                    <h3 style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Icon type="bank" theme="filled" />
                        <span>Bank Account Configuration</span>
                    </h3>
                    <p style={{ color: '#8c8c8c', fontSize: '12px' }}>
                        Configure your business bank accounts to enable financial tracking and receipt generation.
                    </p>
                </div>

                <style>{`
                    .bank-card { background: #fafafa; border-radius: 8px; margin-bottom: 16px; border: 1px solid #f0f0f0; transition: all 0.3s; }
                    .bank-card:hover { border-color: #1890ff; background: #fff; box-shadow: 0 4px 12px rgba(0,0,0,0.05); }
                    .bank-card label { display: block; font-size: 10px; font-weight: 700; color: #8c8c8c; margin-bottom: 4px; text-transform: uppercase; }
                `}</style>

                {bankList.map((bank, index) => {
                    return (
                        <Card loading={this.state.cardLoading} key={index} className="bank-card" bodyStyle={{ padding: '20px' }}>
                            <Row gutter={[16, 16]}>
                                <Col span={8}>
                                    <label>Company Name *</label>
                                    <Input placeholder="Business Name" value={bank.companyName} onChange={function (e) { that.handleChange(index, 'companyName', e.target.value) }} />
                                </Col>
                                <Col span={8}>
                                    <label>Company Type *</label>
                                    <Input placeholder="Private / LLC / Individual" value={bank.companyType} onChange={function (e) { that.handleChange(index, 'companyType', e.target.value) }} />
                                </Col>
                                {/* <Col span={8}>
                                    <label>Company Email *</label>
                                    <Input type="email" placeholder="finance@business.com" value={bank.companyEmail}  onChange={function (e) { that.handleChange(index, 'companyEmail', e.target.value) }} />
                                </Col> */}
                                <Col span={8}>
                                    <label>Company Email *</label>
                                    <Input
                                        type="email"
                                        placeholder="finance@business.com"
                                        value={bank.companyEmail}
                                        onChange={function (e) {
                                            that.handleChange(index, 'companyEmail', e.target.value)
                                        }}
                                        onBlur={function (e) {
                                            var email = e.target.value;

                                            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                                            if (email && !emailRegex.test(email)) {
                                                notification.error({
                                                    message: 'Please Enter Valid Company Email Address'
                                                });
                                            }
                                        }}
                                    />
                                </Col>

                                <Col span={8}>
                                    <label>Bank Name *</label>
                                    <Input placeholder="e.g. HDFC Bank" value={bank.bankName} onChange={function (e) { that.handleChange(index, 'bankName', e.target.value) }} />
                                </Col>
                                <Col span={16}>
                                    <label>Bank Address *</label>
                                    <Input placeholder="Enter full branch address" value={bank.bankAddress} onChange={function (e) { that.handleChange(index, 'bankAddress', e.target.value) }} />
                                </Col>

                                <Col span={8}>
                                    <label>Account Number *</label>
                                    <Input placeholder="1234XXXXXXXX89" value={bank.accountNumber} onChange={function (e) { that.handleChange(index, 'accountNumber', e.target.value) }} />
                                </Col>
                                <Col span={8}>
                                    <label>Beneficiary Name *</label>
                                    <Input placeholder="Account Holder Name" value={bank.accountName} onChange={function (e) { that.handleChange(index, 'accountName', e.target.value) }} />
                                </Col>
                                <Col span={8}>
                                    <label>Status *</label>
                                    <Select style={{ width: '100%' }} value={bank.companyStatus} onChange={function (v) { that.handleChange(index, 'companyStatus', v) }}>
                                        <Option value="Active">Active</Option>
                                        <Option value="Inactive">Inactive</Option>
                                    </Select>
                                </Col>

                                <Col span={6}>
                                    <label>Bank Swift/BIC</label>
                                    <Input placeholder="Swift Code" value={bank.bankSwiftBicCode} onChange={function (e) { that.handleChange(index, 'bankSwiftBicCode', e.target.value) }} />
                                </Col>
                                <Col span={6}>
                                    <label>Bank IFSC Code</label>
                                    <Input placeholder="IFSC" value={bank.bankIfscCode} onChange={function (e) { that.handleChange(index, 'bankIfscCode', e.target.value) }} />
                                </Col>
                                <Col span={6}>
                                    <label>Transit Number</label>
                                    <Input placeholder="Transit No" value={bank.transitNumber} onChange={function (e) { that.handleChange(index, 'transitNumber', e.target.value) }} />
                                </Col>
                                <Col span={6}>
                                    <label>Institution Number</label>
                                    <Input placeholder="Inst No" value={bank.institutionNumber} onChange={function (e) { that.handleChange(index, 'institutionNumber', e.target.value) }} />
                                </Col>

                                <Col span={22}>
                                    <label>HST Registration Number</label>
                                    <Input placeholder="HST No (If applicable)" value={bank.HSTRegistrationNumber} onChange={function (e) { that.handleChange(index, 'HSTRegistrationNumber', e.target.value) }} />
                                </Col>

                                <Col span={2} style={{ textAlign: 'center', paddingTop: '20px' }}>
                                    {bankList.length > 1 && (
                                        <Tooltip title="Remove Bank">
                                            <Icon type="delete" style={{ color: '#ff4d4f', cursor: 'pointer', fontSize: '18px' }} onClick={function () { that.removeBankRow(index) }} />
                                        </Tooltip>
                                    )}
                                </Col>
                            </Row>
                        </Card>
                    );
                })}

                <Button type="dashed" onClick={this.addBankRow} block style={{ height: 45, marginTop: 10, borderRadius: '6px', borderStyle: 'dashed' }}>
                    <Icon type="plus" /> Add Another Bank Account
                </Button>

                <div style={{ marginTop: 35, textAlign: 'right', borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>

                    <div style={{ marginTop: 30, textAlign: 'right', borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
                        {isModal && <Button onClick={this.onPrev} style={{ height: 40, width: 100, marginRight: 10 }}>BACK</Button>}

                        <Button type="primary" onClick={this.handleNext} loading={loading} style={{ height: 40, width: 140 }}>{isModal ? <span>NEXT STEP <Icon type="arrow-right" />`</span> : 'SAVE'}</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default BankSetup;